import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 22"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#i-1500239943__a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    "fill-rule": "evenodd",
    d: "M10.5.5a.593.593 0 0 1 .593.593v8.676l1.328-1.55a.593.593 0 0 1 .902.772l-2.372 2.767a.594.594 0 0 1-.902 0L7.677 8.991a.593.593 0 0 1 .902-.772l1.328 1.55V1.093A.593.593 0 0 1 10.5.5M6.543 6.036a.593.593 0 1 1 .007 1.187c-.865.004-1.477.026-1.943.112-.448.083-.708.215-.9.407-.219.219-.361.527-.44 1.107-.08.597-.081 1.388-.081 2.523v.79c0 1.136.002 1.928.081 2.525.079.58.222.887.44 1.107.22.218.526.36 1.107.439.596.08 1.389.081 2.523.081h6.326c1.134 0 1.926 0 2.524-.081.58-.079.887-.221 1.106-.44.219-.22.361-.526.44-1.106.08-.597.081-1.389.081-2.524v-.79c0-1.136-.002-1.927-.081-2.525-.079-.58-.222-.887-.44-1.106-.193-.192-.452-.324-.9-.407-.466-.086-1.078-.108-1.943-.112a.593.593 0 1 1 .007-1.187c.855.005 1.568.026 2.15.133.6.11 1.11.32 1.525.735.476.475.68 1.075.776 1.787.092.685.092 1.557.092 2.638v.877c0 1.082 0 1.953-.092 2.639-.096.711-.3 1.31-.776 1.787s-1.076.68-1.787.776c-.686.092-1.558.092-2.639.092H7.294c-1.081 0-1.953 0-2.639-.092-.711-.095-1.31-.3-1.787-.776s-.68-1.076-.775-1.787C2 14.159 2 13.287 2 12.206v-.877c0-1.081 0-1.953.093-2.639.094-.712.3-1.31.775-1.787.415-.414.925-.625 1.525-.734.582-.107 1.295-.128 2.15-.133",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "i-1500239943__a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "currentColor",
      d: "M0 21.5h21V.5H0z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }